import { Link } from 'react-router-dom';
import { CTA } from '@/constants/testIds';
import { motion } from 'framer-motion';
import { COMPANY } from '@/data/site';

export default function CtaBanner({ place = 'home' }) {
  return (
    <section className="relative bg-[#1D4ED8] text-white py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-x-0 top-0 h-2 tape opacity-90" />
      <div className="absolute -right-16 -top-16 w-64 h-64 rounded-full bg-[#DC2626]/30 blur-3xl" />
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid md:grid-cols-12 gap-10 items-end relative">
        <div className="md:col-span-8">
          <div className="font-mono-label text-[10px] tracking-[0.28em] uppercase text-white/70 flex items-center gap-3 mb-6">
            <span className="w-8 h-px bg-[#DC2626]" /> Ready when you are
          </div>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
            className="font-display uppercase text-4xl md:text-6xl lg:text-7xl leading-[0.95] tracking-tight max-w-3xl text-white"
          >
            Let's price your project — for free.
          </motion.h2>
          <p className="mt-6 max-w-xl text-white/80 text-base md:text-lg">
            Tell us the scope. We'll come out, measure, and send a fixed-price estimate. No hard sell. Ever.
          </p>
        </div>
        <div className="md:col-span-4 flex flex-col gap-4 md:items-end">
          <Link
            to="/contact"
            data-testid={CTA.estimateBtn(place)}
            className="group inline-flex items-center gap-3 bg-white text-[#1D4ED8] px-7 py-4 font-mono-label text-xs tracking-[0.24em] uppercase hover:bg-[#DC2626] hover:text-white transition-colors"
          >
            Request Free Estimate
            <span className="w-6 h-px bg-[#1D4ED8] group-hover:bg-white group-hover:w-10 transition-[width,background] duration-500" />
          </Link>
          <a
            href={COMPANY.phoneHref}
            className="font-mono-label text-[11px] tracking-[0.22em] uppercase text-white/80 hover:text-white text-right"
          >
            Or call {COMPANY.phone}
            <span className="block text-white/60 mt-0.5">Direct · {COMPANY.phoneAlt}</span>
          </a>
        </div>
      </div>
    </section>
  );
}
